import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { Response } from '@frontend/sorghum/interface';
import { FLOW_GROUP } from '../apis';
import { toast } from 'react-toastify';
import { queryClient } from '@frontend/sorghum/external-providers';

async function postEditorFlowGroup(props: Props): Promise<Response> {
  return axios
    .post(`${FLOW_GROUP}`, props)
    .then((res) => res.data)
    .catch((err) => ({
      code: 400,
      msg: err,
    }));
}

interface Props {
  projectId: string;
  name: string;
}

export function usePostEditorFlowGroup() {
  return useMutation({
    mutationKey: ['post-editor-flow-group'],
    mutationFn: (props: Props) => postEditorFlowGroup(props),
    onSuccess: (data) => {
      if (data.code === 20000) {
        queryClient.refetchQueries(['editor-flow-group']);
        toast.success(data.msg);
      } else {
        toast.warn(data.msg);
      }
    },
  });
}

export default usePostEditorFlowGroup;
